const BulletStyle = {
    POSITIVE: 'positive',
    NEGATIVE: 'negative',
    QUESTION_MARK: 'question',
    REGULAR: 'regular',
    NONE: 'none'
};

export default BulletStyle;
